import { Route } from 'react-router-dom';
import Homepage from '../pages/homepage/Homepage';

export default [
  <Route exact path='/' component={Homepage} key='homepageRoute' />,
];
